<template>
  <div class="group">
    <div class="group-header">
      <div class="group-title">
        <i class="title-decorate iconfont icon-decorate" />
        <span>预约信息</span>
      </div>
      <div class="count-down">请在<span class="quoteinfo-time">{{ m }}</span>分<span class="quoteinfo-time">{{ s }}</span>秒 内填写完成数据，否则预约单将会被取消</div>
    </div>

    <el-row class="group-box">
      <el-col class="group-cell" :span="8">
        <div class="group-label">预约单号</div>
        <div class="group-value">{{ data.reservationNo }}</div>
      </el-col>
      <el-col class="group-cell" :span="8">
        <div class="group-label"> 预约卸货点</div>
        <div class="group-value">{{ data.parkingLotNo }}</div>
      </el-col>
      <el-col class="group-cell" :span="8">
        <div class="group-label">预约时间</div>
        <div class="group-value">{{ data.appointmentDate }}</div>
      </el-col>
      <el-col class="group-cell" :span="8">
        <div class="group-label">预约仓库</div>
        <div class="group-value">{{ data.receiptWareName }}</div>
      </el-col>
      <el-col class="group-cell" :span="8">
        <div class="group-label">仓库地址</div>
        <div class="group-value">{{ data.wareDetailAddress }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import http from '@/plugin/axios'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      timer: null,
      m: 0,
      s: 0
    }
  },
  computed: {
    endTime() {
      return this.data.endTime
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    countDown() {
      if (new Date(this.endTime).getTime() <= Date.now()) {
        this.endPerfect()
        return
      }
      this.timer = setInterval(() => {
        const time = Math.floor(new Date(this.endTime).getTime() / 1000)
        let rest = time - Math.floor(Date.now() / 1000)
        const m = Math.floor(rest / 60)
        rest = rest % 60
        const s = Math.floor(rest)
        this.m = m
        this.s = s
        if (!m && !s) {
          clearInterval(this.timer)
          this.endPerfect(true)
          return
        }
      }, 1000)
    },
    async endPerfect(sendMessage) {
      if (sendMessage) {
        http({
          url: '/srmDeliveryAppoint/timeOutClose',
          baseURL: process.env.VUE_APP_PURCHASE_API,
          data: { ids: this.list.map(i => i.id) }
        })
      }
      this.$alert('预约单已经取消，是否退出？', {
        // confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$router.push({ name: 'Myappointment.Myappointment' })
          } else {
            this.$router.back()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  background: #fff;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 18px;
  margin-bottom: 12px;
  &-header {
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 18px;
  }
  &-title {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 -10px;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
  }

  &-box {
    border: 1px #E1E1E1 dashed;
    padding-top: 10px;
  }
  &-cell {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  &-label {
    width: 60px;
    padding: 0 10px;
  }
}

.count-down {
  min-width: 170px;
  font-size: 14px;
  background-color: #FFF8E3;
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
  color: #333333;
  font-weight: normal;
  position: relative;
}

.count-down::before {
  content: '';
  display: inline-block;
  height: 100%;
  width: 20px;
  background-color: #FFF8E3;
  transform: skew(-20deg);
  position: absolute;
  top: 0;
  left: -10px;
  border-radius: 6px;
}

.quoteinfo-time {
  display: inline-block;
  color: #F9C535;
  min-width: 22px;
  text-align: center;
  font-weight: bold;
}
</style>
